import { Arg, Metadata } from '../../../../../utils/spds/metadata';
import FlexRow from '../../../layout/flex/row.gjs';
import Super from '../../../core/base.gjs';

const METADATA = Metadata.define({
  description: 'Title for standard modal header.',
  meta: {
    title: Arg.string({ description: 'Title text' }).required(),
  },
  name: 'Title',
});

export default class SpdsModalStandardHeaderTitle extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal-standard-header-title';

  <template>
    <FlexRow
      @tag="h1"
      class={{this.classes}}
      data-test-spds-modal-standard-header-title
      {{this.validateArguments}}
      ...attributes
    >
      {{@title}}
    </FlexRow>
  </template>
}

export const MODAL_STANDARD_HEADER_TITLE_METADATA = SpdsModalStandardHeaderTitle.metadata;
